import '../../vendor/time-circles.js'
import { isPhone } from '../utils/base-init.js'
import { getCookie, setCookie, setCookieMins } from '../utils/cookie.js'
import { showLoadingModal } from '../transitions/show-loading-modal.js'
import { swalOption } from './swal-opt.js'

window.promptMoreTime = getCookie('alreadyPromptMoreTime') === ''
window.alertMsgShowed = false

export function timeCirclesOptions(finalCountDownSeconds, count) {
	const borderWidth = isPhone ? 0.05 : 0.22
	const bgWidth = isPhone ? 0.7 : 1.2

	return {
		ref_date: new Date().getTime() + count * 1000, // Time in seconds to start from (900s = 15 mins).
		total_duration: finalCountDownSeconds,
		animation: 'smooth',
		bg_width: bgWidth,
		fg_width: borderWidth,
		circle_bg_color: '#b34401',
		custom_time_draw: true,
		direction: 'Counter-clockwise',
		/* Our own attrib, means we draw the time label using listener below */
		time: {
			Days: {
				show: false,
			},
			Hours: {
				show: false,
			},
			Minutes: {
				text: '',
				color: '#fff09f',
				show: false,
			},
			Seconds: {
				text: '',
				color: '#fff09f',
				show: true,
			},
		},
	}
}

export function initCheckoutTimer(countDownSeconds, alertMessage, reload) {
	const timerDiv = '#mobile-header-timer-seating-chart'
	const finalCountDownSeconds =
		getCookie('promptMoreTimeValue') === ''
			? window.theme.countDownSeconds // 900s
			: window.theme.finalCountDownSeconds // 1200s
	// var finalCountDownSeconds = getCookie('promptMoreTimeValue') == '' ? 60 : 120
	const count = finalCountDownSeconds - countDownSeconds
	// var alertMsg = alertMessage
	const countdownListener = function (unit, value, total) {
		let s = value
		const m = Math.floor(s / 60) // Get remaining minutes
		s -= m * 60
		const mobileTime = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s)
		const desktopTime = window.myvars.desktopCounterTimeDisplay
			.replace(':minutes', m)
			.replace(':seconds', s)

		$('#mobile-header-timer-time').text(desktopTime)
		if (isPhone)
			$(timerDiv).find('.time_circles .textDiv_Seconds span').text(mobileTime)

		if (total === 30 && window.promptMoreTime) {
			$('#msg-holder-time-circle')
				.modal('show')
				.on('hidden.bs.modal', function (e) {
					setCookie('alreadyPromptMoreTime', true, 30, '')
				})

			$('[data-add-more-time-btn]').on('click', function (event) {
				const _count = window.theme.extendCartSeconds // 300
				// var _count = 60
				$(timerDiv)
					.TimeCircles(timeCirclesOptions(_count, _count))
					.rebuild()
				$('#msg-holder-time-circle').modal('hide')
			})

			window.promptMoreTime = false
			setCookieMins('promptMoreTimeValue', true, 5, '')
			// setCookieMins('promptMoreTimeValue', true, 1, '')
		} else if (total <= 0) {
			const timeCircles = $(this)
			const $scheduleEid = getCookie('scheduleEid')
			const commingFromBestAvailable =
				getCookie('choiceSeat') === 'fromBestAvailable'
			const commingFromSC = getCookie('choiceSeat') === 'fromSC'
			const commingFromBundle = getCookie('choiceSeat') === 'fromBundle'
			const level = () =>
				getCookie('currentLevel') !== '' ? getCookie('currentLevel') : 1
			
			let targetLink = ''
			if (commingFromBestAvailable) {
			 	targetLink = '/choice/best-available'
			} else if (commingFromBundle) {
				 targetLink = '/choice/bundle'

			} else if (commingFromSC) {
				targetLink = '/sc/1/level' + level
			} else {
				targetLink = '/choice/seating-chart'
			}

			const $nextURL = '/event/view/view/schedule/' + $scheduleEid + targetLink

			return new Promise((resolve, reject) => {
				// alert(alertMsg)
				if (!window.alertMsgShowed) {
					window.alertMsgShowed = true
					Swal.fire(swalOption(alertMessage, false)).then((result) => {
						if (result.value) {
							timeCircles.TimeCircles().destroy()
							setCookie('promptMoreTimeValue', '', 1, '')
							resolve()
						}
					})
				} else {
					timeCircles.TimeCircles().destroy()
					setCookie('promptMoreTimeValue', '', 1, '')
					reject()
				}
			}).then(
				() => {
					showLoadingModal()

					$.post('/store/shopping-cart/remove-all/expired/1', (data) => {
						if (reload) {
							window.location.reload(true)
						} else {
							window.location.href = $nextURL
						}
					})
				},
				() => {
					$.post('/store/shopping-cart/remove-all/expired/1', (data) => {
						if (reload) {
							window.location.reload(true)
						} else {
							window.location.href = $nextURL
						}
					})
				}
			)
		}
	}

	$(timerDiv)
		.TimeCircles(timeCirclesOptions(finalCountDownSeconds, count))
		.addListener(countdownListener)
}

export function extendCountDown(count = 600) { // default extend 10 minutes
	const timerDiv = '#mobile-header-timer-seating-chart'
	// $(timerDiv).TimeCircles(timeCirclesOptions(count, count)).rebuild()
	$(timerDiv).TimeCircles().stop()
}

export function restartCountDown() { // default extend 10 minutes
	const timerDiv = '#mobile-header-timer-seating-chart'
	$(timerDiv).TimeCircles().restart()
}


export function stopCountDown() { // default extend 10 minutes
	const timerDiv = '#mobile-header-timer-seating-chart'
	$(timerDiv).TimeCircles().destroy()
}


window.timeCirclesOptions = timeCirclesOptions
// window.initCheckoutTimer = initCheckoutTimer

export default initCheckoutTimer
